import React from "react";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "./narrowInput.css";

/**
 * NarrowDatePicker
 * A styled date picker matching the NarrowInputField design.
 *
 * Props:
 * - value: Date object or null (not a string!)
 * - onChange: function(Date|null)
 */
const NarrowDatePicker = ({
  title,
  subLabel,
  placeholder,
  isRequired,
  value, // should be a Date object or null
  onChange,
  readOnly = false,
  halfWidth = false,
  name,
}) => {
  return (
    <div className={`input-field-container ${halfWidth ? "half-width" : ""}`}>
      <label className="input-label">
        {title} {isRequired && <span className="required">*</span>}
      </label>
      {subLabel && <div className="sub-label">{subLabel}</div>}

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          value={value} // value must be a Date object or null
          onChange={onChange}
          inputFormat="yyyy-MM-dd"
          disableMaskedInput={false}
          renderInput={(params) => (
            <TextField
              {...params}
              name={name}
              required={isRequired}
              placeholder={placeholder}
              InputProps={{
                ...params.InputProps,
                readOnly: readOnly,
              }}
              className={`narrow-input-field ${readOnly ? "read-only" : ""}`}
            />
          )}
        />
      </LocalizationProvider>
    </div>
  );
};

export default NarrowDatePicker;
